import styled from 'styled-components';
import {
  TYPOGRAPHY_FONT_WEIGHT_MAP,
  TYPOGRAPHY_VARIANT_MAP,
  TypographyFontWeightType,
  TypographyVariantType,
} from '@/styles/typography';
import { BoxWrapper } from '../Box/styles';

export type TypographyCustomPropsType = {
  variant?: TypographyVariantType;
  fontWeight?: TypographyFontWeightType;
};

export const TypographyContainer = styled(BoxWrapper)<TypographyCustomPropsType>`
  ${({ variant }) => `${TYPOGRAPHY_VARIANT_MAP[variant]};`};

  ${({ fontWeight }) => `${TYPOGRAPHY_FONT_WEIGHT_MAP[fontWeight]};`};
`;
